function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { contains } from '../../util';
import { isSignalRef } from '../../vega.schema';
import { isConcatModel, isLayerModel } from '../model';
export function assembleProjections(model) {
  if (isLayerModel(model) || isConcatModel(model)) {
    return assembleProjectionsForModelAndChildren(model);
  } else {
    return assembleProjectionForModel(model);
  }
}
export function assembleProjectionsForModelAndChildren(model) {
  return model.children.reduce(function (projections, child) {
    return projections.concat(child.assembleProjections());
  }, assembleProjectionForModel(model));
}
export function assembleProjectionForModel(model) {
  var component = model.component.projection;
  if (!component || component.merged) {
    return [];
  }
  var projection = component.combine();
  var name = projection.name; // we need to extract name so that it is always present in the output and pass TS type validation
  if (!component.data) {
    // generate custom projection, no automatic fitting
    return [_objectSpread({
      name: name,
      // translate to center by default
      translate: {
        signal: '[width / 2, height / 2]'
      }
    }, projection)];
  } else {
    // generate projection that uses extent fitting
    var size = {
      signal: "[".concat(component.size.map(function (ref) {
        return ref.signal;
      }).join(', '), "]")
    };
    var fits = component.data.reduce(function (sources, data) {
      var source = isSignalRef(data) ? data.signal : "data('".concat(model.lookupDataSource(data), "')");
      if (!contains(sources, source)) {
        // build a unique list of sources
        sources.push(source);
      }
      return sources;
    }, []);
    if (fits.length <= 0) {
      throw new Error("Projection's fit didn't find any data sources");
    }
    return [_objectSpread({
      name: name,
      size: size,
      fit: {
        signal: fits.length > 1 ? "[".concat(fits.join(', '), "]") : fits[0]
      }
    }, projection)];
  }
}